import logoUrl from "@/assets/fitlynk-logo.png";

// Official FitLynk logo — transparent PNG with light lettering, rendered directly on
// the app's dark surfaces (no background plate/chip). `size` sets the responsive
// height; `className` applies layout (margins/alignment). Aspect ratio preserved.
export function Logo({ size = "h-7", className = "", testid = "fitlynk-logo" }) {
  return (
    <span className={`inline-flex items-center ${className}`} data-testid={testid}>
      <img
        src={logoUrl}
        alt="FitLynk"
        draggable={false}
        className={`${size} w-auto object-contain shrink-0 select-none`}
      />
    </span>
  );
}
